const CHAT_INPUT_MODES = {
  chat: 'INPUT_TYPE_CHAT',
  email: 'INPUT_TYPE_EMAIL',
  loading: 'INPUT_TYPE_LOADING',
  name: 'INPUT_TYPE_NAME',
  none: 'INPUT_TYPE_NONE',
  back: 'INPUT_TYPE_BACK',
  question: 'INPUT_TYPE_QUESTION',
  restart: 'INPUT_TYPE_RESTART',
} as const;

type ChatInputMode = (typeof CHAT_INPUT_MODES)[keyof typeof CHAT_INPUT_MODES];

export { CHAT_INPUT_MODES, type ChatInputMode };
